import { useMemo } from 'react';

import { useGetProjectsQuery, useSelectedProjectId } from 'features/projects';

import { useGetMasterWithSubsQuery } from '../api/master.api';

const useSelectedMasterProject = () => {
  const selectedId = useSelectedProjectId();
  const { data: allProjects = [] } = useGetProjectsQuery();

  const masterId = useMemo(() => {
    if (selectedId == null) return null;
    const project = allProjects.find((item) => item.id === selectedId);
    if (!project) return selectedId;
    return project.masterProjectId ?? project.id;
  }, [allProjects, selectedId]);

  const query = useGetMasterWithSubsQuery(masterId ?? 0, {
    skip: masterId == null,
  });

  return {
    masterId,
    selectedId,
    ...query,
  };
};

export default useSelectedMasterProject;
